import { createClient as createSupabaseClient } from '@supabase/supabase-js'

export function createClient() {
  return createSupabaseClient(
    import.meta.env.VITE_SUPABASE_URL!,
    import.meta.env.VITE_SUPABASE_ANON_KEY!,
    {
      auth: {
        // Use implicit flow for backend-mediated auth
        // PKCE is handled server-side in our custom auth endpoints
        flowType: 'implicit',
        // Automatically detect auth flow type from URL for email confirmation
        detectSessionInUrl: true,
        // Persist session across tabs/windows
        persistSession: true,
        // Store session in localStorage
        storage: window.localStorage,
      },
    }
  )
}
